import { Mixpanel, MixpanelEvents } from "../../services/Mixpanel";
import constants from "../../constants";

const { MIXPANEL_FOOTER_CONFIG } = constants;

/**
 * Get page name from pathname
 * @param {string} pathname - Current page pathname
 * @returns {string} - Formatted page name
 */
const getPageName = pathname => {
  if (!pathname || pathname === "/") return "Homepage";

  // Remove leading/trailing slashes and convert to title case
  const pageName = pathname
    .replace(/^\/|\/$/g, "")
    .split("-")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return pageName || "Homepage";
};

/**
 * Track footer navigation link clicks
 * @param {string} linkLabel - Label of the navigation link
 * @param {string} pathname - Current page pathname
 */
export const trackFooterNavClick = (linkLabel, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.nav_link_clicked, {
    page_name: pageName,
    asset: MIXPANEL_FOOTER_CONFIG.asset,
    asset_name: MIXPANEL_FOOTER_CONFIG.assetName,
    cta_text: linkLabel,
    cta_location: MIXPANEL_FOOTER_CONFIG.locations.footer,
  });
};

/**
 * Track social media link clicks
 * @param {string} socialName - Name of the social media platform
 * @param {string} pathname - Current page pathname
 */
export const trackSocialClick = (socialName, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.social_icon_clicked, {
    page_name: pageName,
    asset: MIXPANEL_FOOTER_CONFIG.asset,
    asset_name: MIXPANEL_FOOTER_CONFIG.assetName,
    cta_text: `${socialName} Icon`,
    cta_location: MIXPANEL_FOOTER_CONFIG.locations.footer,
  });
};

/**
 * Track app store link clicks
 * @param {string} storeName - Name of the app store (App Store/Play Store)
 * @param {string} pathname - Current page pathname
 */
export const trackAppStoreClick = (storeName, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.store_cta_clicked, {
    page_name: pageName,
    asset: MIXPANEL_FOOTER_CONFIG.asset,
    asset_name: MIXPANEL_FOOTER_CONFIG.assetName,
    cta_text: storeName,
    cta_location: MIXPANEL_FOOTER_CONFIG.locations.footer,
  });
};

/**
 * Track contact info clicks (phone/email)
 * @param {string} contactType - Type of contact (Phone/Email)
 * @param {string} pathname - Current page pathname
 */
export const trackContactClick = (contactType, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.contact_button_clicked, {
    page_name: pageName,
    asset: MIXPANEL_FOOTER_CONFIG.asset,
    asset_name: MIXPANEL_FOOTER_CONFIG.assetName,
    cta_text: contactType,
    cta_location: MIXPANEL_FOOTER_CONFIG.locations.footer,
  });
};

/**
 * Track legal link clicks (Privacy Policy/Terms of Use)
 * @param {string} linkLabel - Label of the legal link
 * @param {string} pathname - Current page pathname
 */
export const trackLegalLinkClick = (linkLabel, pathname) => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.legal_link_clicked, {
    page_name: pageName,
    asset: MIXPANEL_FOOTER_CONFIG.asset,
    asset_name: MIXPANEL_FOOTER_CONFIG.assetName,
    cta_text: linkLabel,
    cta_location: MIXPANEL_FOOTER_CONFIG.locations.footer,
  });
};

/**
 * Track footer logo clicks
 * @param {string} pathname - Current page pathname
 */
export const trackFooterLogoClick = pathname => {
  const pageName = getPageName(pathname);

  Mixpanel.track(MixpanelEvents.logo_clicked, {
    page_name: pageName,
    asset: MIXPANEL_FOOTER_CONFIG.asset,
    asset_name: MIXPANEL_FOOTER_CONFIG.assetName,
    cta_text: "Twin Health India Logo",
    cta_location: MIXPANEL_FOOTER_CONFIG.locations.footer,
  });
};
